export default "__VITE_ASSET__73bfaf36__"